import { render, staticRenderFns } from "./activityType.vue?vue&type=template&id=32223a9a&scoped=true&"
import script from "./activityType.vue?vue&type=script&lang=js&"
export * from "./activityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32223a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32223a9a')) {
      api.createRecord('32223a9a', component.options)
    } else {
      api.reload('32223a9a', component.options)
    }
    module.hot.accept("./activityType.vue?vue&type=template&id=32223a9a&scoped=true&", function () {
      api.rerender('32223a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityType/activityType.vue"
export default component.exports